module.exports = __webpack_public_path__ + "img/b2.006ccd67.png";